import React from "react";

export const SettingsRow = ({ title, description, children }) => {
	return (
		<>
			<div className="tw-border-b !border-b-gray-200 py-3">
				<div className="grid grid-cols-12 gap-10">
					<div className="col-span-5">
						<p className="text-base my-0 font-bold">{title}</p>
						{description ? (
							<p className="text-base my-0 text-gray-400">{description}</p>
						) : null}
					</div>

					<div className="col-span-7">{children}</div>
				</div>
			</div>
		</>
	);
};

{
	/* <SettingsField>
  <SettingsField.Title description="">

  </SettingsField.Title>

  <SettingsField.Content>
    <Field />
  </SettingsField.Content>
</SettingsField> */
}
